import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TabContext } from "../../../../../../context/AppContext";

const TabModal = ({ isOpen, onClose}) => {
  const navigate = useNavigate();
  const { activeTab, handleTabClick } = useContext(TabContext);

  const [selectedOption, setSelectedOption] = useState("Public");

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
    onClose();
  };

  const handleTabClickWithNavigate = (tab) => {
    handleTabClick(tab);
    if (tab === "Public") {
      navigate('/home');
    } else if (tab === "Corporate") {
      navigate('/corporate-home');
    }
  };

  return (
    <div className="tab-modal-container" onClick={() => onClose()}>
      <div className="container" onClick={(e) => e.stopPropagation()}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "10px",
          }}
        >
          <label htmlFor="public" style={{ color: "black", fontSize: "21px", width: "100%" }}>Public</label>
          <input
            type="radio"
            id="public"
            value="Public"
            checked={activeTab === "Public"}
            onChange={() => {
              handleTabClickWithNavigate("Public");
              onClose();
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "10px",
          }}
        >
          <label htmlFor="corp" style={{ color: "black", fontSize: "21px", width: "100%" }}>Corporate</label>
          <input
            type="radio"
            id="corp"
            value="Corporate"
            checked={activeTab === "Corporate"}
            onChange={() => {
              handleTabClickWithNavigate("Corporate");
              onClose();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TabModal;
